import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"

import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Tooltip, LayersControl } from 'react-leaflet';
import rd from "assets/icons/pin2.png";

    const GIS = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [payments, setPayments] = useState([])
        const [isLoading, setIsLoading] = useState(false)
        const [areas, setAreas] = useState([])

        
        const [statusOptions, setStatusOptions] = useState(['Open', 'Verified', 'Rejected'])
        const [vendorOptions, setVendorOptions] = useState(['eDahab', 'ZAAD'])
        const [currencies, setCurrencies]       = useState(['SLSH', 'USD'])

        const [sDate, setSDate]         = useState([])
        const [eDate, setEDate]         = useState([])
        const [sArea, setSArea]         = useState('')
        const [sStatus, setSStatus]     = useState('')
        const [sRefNo, setSRefNo]       = useState('')
        const [sPhoneNo, setSPhoneNo]   = useState('')
        const [sCurrency, setSCurrency] = useState('')
        const [sName, setSName]         = useState('')
        const [supplyNo, setSSupplyNo]  = useState('')
        const [sVendor, setSVendor]     = useState('')

        const [id, setId] = useState('')
        const [dateTime, setDateTime]           = useState([new Date()])
        const [supNo, setSupNo]                 = useState('')
        const [customer, setCustomer]           = useState('')
        const [phone, setPhone]                 = useState('')
        const [paymentRef, setPaymentRef]       = useState('')
        const [vendor, setVendor]               = useState('')
        const [amountSLSH, setAmountSLSH]       = useState('')
        const [amountUSD, setAmountUSD]         = useState('')
        const [userId, setUserId]               = useState('')
        const [username, setUserName]           = useState('')
        const [status, setStatus]               = useState('Verified')
        const [receiptNo, setReceiptNo]         = useState('')
        const [dateTimeVerified, setDateTimeVerified]  = useState([new Date()])
        
        const [modal_cash, setmodal_cash] = useState(false);
        const [isloading, setIsloading] = useState(false)
        const [zoom, setZoom] = useState(4)
        const [center, setCenter] = useState([9.426039, 46.270828])
        const mapRef = useRef(null);
        const [lat, setLat] = useState(null);
        const [lng, setLng] = useState(null);

        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_cash = () => {
          setmodal_cash(!modal_cash);
          removeBodyCss();
        }

        const redPoint = L.icon({
          iconUrl:rd,
          iconSize: [26, 51], 
          iconAnchor: [14, 80], 
          popupAnchor: [-3, -76] 
        })
       
        const fetchData = () => {
          const data = {
            supplyNo  : supplyNo
          }
          setIsLoading(true)
          axios.post(url.BILLINGSERVERDATA, JSON.stringify(data), Config).then((r)=>{ 
            setPayments(r.data.data)
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
          axios.get(`${url.TERRITORIES}`, Config).then((r)=>{ 
            setAreas(r.data);
          }).catch((e)=>{  
            console.log(e);
          });
 
          const obj = JSON.parse(localStorage.getItem("authWTUser"));
          setUserId(obj.id)
          setUserName(obj.username)

        }
        
        useEffect(() => {
          fetchData();
        },[]);

        
        
        const handleFilterData = () =>{
          const data = {
            supplyNo  : supplyNo
          }
          setIsLoading(true)
          axios.post(url.BILLINGSERVERDATA, JSON.stringify(data), Config).then((r)=>{ 
            setPayments(r.data.data)
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        const handleClearSearch = () =>{
          setSSupplyNo('')
          setSName('')
          setSPhoneNo('')
          setSVendor('')
          setSRefNo('')
          setSArea('')
          setSStatus('')
          setSCurrency('')
          setSDate('')
          setEDate('')
          handleFilterData()
        }


        const pageOptions = {
          sizePerPage: 100,
          totalSize: payments.length, // replace later with size(orders),
          custom: true,
        }
        var node = useRef();
              
        const columns = [


        {
            dataField: 'full_name',
            text: 'Supply No',
            sort: true
        },
        {
            dataField: 'customer_name',
            text: 'Customer Name',
            sort: true
        }, 
        {
            dataField: 'amount_balance',
            text: 'Outstanding Balance',
            sort: true,
            //formatter: (cell, row) => (parseFloat(cell)).toLocaleString(),
            headerAlign: 'right',
            align: 'right', 
        },
        {
            dataField: 'lc_currency_id',
            text: 'Currency',
            sort: true,
            formatter: cFormatter
        },
        {
          dataField: '',
          text: '',
          sort: true,
          formatter: actionFormatter
      }
      ];

        const defaultSorted = [{
          dataField: 'full_name',
          order: 'desc'
        }];

        function cFormatter(cellContent, row){
            if(cellContent == '177'){
                return(<strong>SLSH</strong>)
            }else{
                return(<strong>USD</strong>)
            }
          
        }
        function gFormatter(cellContent, row){
          const data = {supplyNo: row.full_name}
          axios.post(url.GIS, JSON.stringify(data))
          .then((response) => {
            const { data } = response;
            if (data.latitude) {
              return(<strong>Mapped</strong>)
            } else {
              return(<strong>Not Mapped</strong>)
            }
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
      }
        function actionFormatter(cellContent, row){
          /*
          const data = {supplyNo: row.full_name}
          axios.post('http://41.79.196.12/hwa_gis/', JSON.stringify(data))
          .then((response) => {
            const { data } = response;
            if (data.latitude) {
              return(<Button color="success" className="btn-sm btn-rounded" onClick={() => { handleClickDetails(row); }}>Details</Button>)
            } else {
              return(<Button color="danger" className="btn-sm btn-rounded" onClick={() => { handleClickDetails(row); }}>Details</Button>)
            }
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
          */
          return(<Button color="info" className="btn-sm btn-rounded" onClick={() => { handleClickDetails(row); }}>Details</Button> )
        }
        
        const handleClickDetails = (row) =>{
          
          setSupNo(row.full_name)
          setAmountSLSH(row.amount_balance)
          setCustomer(row.customer_name)
          const data = { supplyNo: row.full_name }; 
          axios.post(url.GIS, JSON.stringify(data))
            .then((response) => {
              const { data } = response;
              if (data.latitude) {
                tog_cash();
                const lati = parseFloat(data.longitude)
                const long = parseFloat(data.latitude)
                zoomIn();
                setLat(lati);
                setLng(long);
                setMapCenterAnimated(lati, long);
              } else {
                zoomOut();
                setLat(null);
                setLng(null);
                setMapCenterAnimated(9.426039, 46.270828);
                toastr.info('Supply number has no GIS data')
              }
            })
            .catch((error) => {
              console.error('Error fetching data:', error);
            });
        }
        const zoomIn = () => {
            if (mapRef.current) {
              const map = mapRef.current; 
              const currentZoom = map.getZoom(); 
              map.setZoom(17); 
            }
          };
        
          const zoomOut = () => {
            if (mapRef.current) {
              const map = mapRef.current; 
              const currentZoom = map.getZoom(); 
              map.setZoom(5); 
            }
          };
    
          const setMapCenterAnimated = (lat, lng) => {
            setCenter([lat, lng]); 
            if (mapRef.current) {
              mapRef.current.flyTo([lat, lng], mapRef.current.getZoom(), {
                duration: 5, 
                animate: true 
              });
            }
          };
  
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>GIS - BILLING | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                      <Modal isOpen={modal_cash} toggle={() => { tog_cash();}} centered size='xl'>
                      <div className="modal-header">
                          <h5 className="modal-title mt-0" id="myModalLabel">{ supNo } | <strong>{amountSLSH}</strong> </h5>
                          <button onClick={() => { setmodal_cash(false);}}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        
                        
                            <MapContainer center={center} zoom={4} ref={mapRef} style={{ height: '500px', width: '100%' }}>
                            <LayersControl position="topright">
                              <LayersControl.BaseLayer name="Satellite">
                                <TileLayer
                                  attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                                  url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                                  id="mapbox/satellite-v9" 
                                  accessToken={process.env.REACT_APP_APIKEY}
                                />
                              </LayersControl.BaseLayer>
                              <LayersControl.BaseLayer checked name="Street">
                                <TileLayer
                                    attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                                    url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                                    id="mapbox/streets-v11" 
                                    accessToken={process.env.REACT_APP_APIKEY}
                                  />
                              </LayersControl.BaseLayer>
                              </LayersControl>
                                {lat && lng && <Marker position={[lat, lng]} icon={redPoint}><Tooltip><strong>{supNo}</strong><br/>{customer}</Tooltip></Marker>}
                            </MapContainer>
                          
                                
                    
                      </Modal>
                     
                        <Row>
                                      
                            <Col lg="12">
           
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Billing and location data</h5>
                                <CardBody>
  
                                {(payments.length > 0) && (

                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="full_name"
                                    columns={columns}
                                    data={payments}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="full_name"
                                      data={payments}
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                            
                                                <BootstrapTable 
                                                  keyField='full_name' 
                                                  data={payments} 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  //onTableChange={handleTableChange}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {payments && (payments.length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No data found</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                    
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default GIS;